import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
	ChangeDetectorRef
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { IPointEvent } from './point.type';

@Component({
	selector: 'rbc-point',
	templateUrl: './point.component.html',
	styleUrls: ['./point.component.scss']
})
export class PointComponent implements OnInit, OnDestroy, OnChanges {
	@Input() id: string;
	@Input() label: string;
	@Input() helpText: string;
	@Input()
	get disabled(): string | boolean {
		return this._disabled;
	}
	set disabled(val: string | boolean) {
		this._disabled = val;
		this.disable = val;
		this.cd.detectChanges();
	}
	@Input()
	get checked(): string | boolean {
		return this._checked;
	}
	set checked(val: string | boolean) {
		this._checked = val;
		this.active = val;
		this.cd.detectChanges();
		this.active = this.checked;
	}
	@Input()
	get completed(): string | boolean {
		return this._completed;
	}
	set completed(val: string | boolean) {
		this._completed = val;
		this.done = val;
		this.cd.detectChanges();
	}
	@Input()
	get passed(): string | boolean {
		return this._passed;
	}
	set passed(val: string | boolean) {
		this._passed = val;
		this.skipped = val;
		this.cd.detectChanges();
	}
	@Input() editable: boolean = true;
	@Input() number: string | number;

	@Output() pointUpdate = new EventEmitter<IPointEvent>();

	msg: string = 'Default';
	firstChange: boolean = true;
	_active: string | boolean = false;
	get active(): string | boolean {
		return this._active;
	}
	set active(val: string | boolean) {
		this._active = val;
		this.firePointUpdate();
	}
	done: string | boolean = false;
	skipped: string | boolean = false;
	disable: string | boolean = false;
	private _disabled: string | boolean = false;
	private _checked: string | boolean = false;
	private _completed: string | boolean = false;
	private _passed: string | boolean = false;

	constructor(private idService: IdService, private cd: ChangeDetectorRef) {}

	ngOnInit() {
		this.id = this.id ? this.id : this.idService.generate();
		this.syncChanges();
		this.firstChange = false;
	}

	ngOnDestroy() {
		// release id
		this.idService.remove(this.id);
	}

	// parent changes
	ngOnChanges(changes: SimpleChanges): void {
		this.syncChanges();
		this.firePointUpdate();
	}

	syncChanges() {
		this.active = this.checked;
		this.done = this.completed;
		this.skipped = this.passed;
		this.disable = this.disabled;
	}

	/* logic */
	updateActive() {
		if (!this.disabled && this.editable) {
			this.active = !this.active;
		}
	}

	// Event is fired when the state of the Point has been changed.
	// This includes when the checked, completed, disabled, passed values have been updated.
	firePointUpdate() {
		if (!this.firstChange) {
			this.pointUpdate.emit({
				id: this.id,
				active: this.active,
				completed: this.completed,
				passed: this.skipped,
				disabled: this.disable
			});
		}
	}

	describedby() {
		let label = this.label ? `${this.id}Label` : null;
		let helpText = this.helpText ? `${this.id}HelpText` : null;
		return label + helpText;
	}

	pressedState() {
		return this.done ? 'true' : this.active ? 'mixed' : 'false';
	}

	/* utility */
}
